import { setOptions } from './internal';

function configure (options) {
  setOptions(options);
}

export default configure;



// WEBPACK FOOTER //
// ./imageLoader/configure.js